const lowerCaseQueryParam = (queryParam) => Object.keys(queryParam).reduce((query, key) => {
    query[key.toLowerCase()] = queryParam[key];
    return query;
}, {});

export default lowerCaseQueryParam;
